<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col class="text-center">
        <h1>
          {{ $t("limitReached.title") }}
        </h1>
        <h4>
          <i18n path="limitReached.home">
            <template v-slot:action>
              <router-link :to="{ name: 'Home' }" exact>{{
                $t("limitReached.action")
              }}</router-link>
            </template>
          </i18n>
        </h4>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "LimitReached"
};
</script>
